import http from "../api-common";
var baseURL = process.env.VUE_APP_API_URL

class DataService {

  getPrompts() {
    return http.get(baseURL+'/getPrompts');
  }

  getPrompt(pid) {
    return http.get(baseURL+'/getPrompt', {params: {'pid': pid}});
  }

  getAllResponses() {
    return http.get(baseURL+'/getResponses');
  }

  getResponsesForPrompt(pid) {
    return http.get(baseURL+'/getResponsesForPrompt', {params: {'pid': pid}});
  }

  getUserResponses(uid) {
    return http.get(baseURL+'/getUserResponses', {params: {'uid': uid}});
  }

  getResponse(rid) {
    return http.get(baseURL+'/getResponse', {params: {'id': rid}});
  }

  getGenResponse(rid) {
    return http.get(baseURL+'/getGenresponse', {params: {'id': rid}});
  }

  getGenPrompt() {
    return http.get(baseURL+'/getGenprompt');
    // return http.get('https://gpt2-tubtkhjdya-nn.a.run.app/', {params: {'length': 100, 'temperature': 1.7, 'include_prefix': false}})
  }

  createResponse(data) {
    return http.post(baseURL+'/putResponse', data);
  }

  createGenprompt(data) {
    return http.post(baseURL+'/putGenprompt', data);
  }

  emailResponse(data) {
    return http.post(baseURL+'/emailResponse', data);
  }
}

export default new DataService();
